import { jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { currentTimeMillis, Second } from '@nu-art/ts-common';
export class Component_LoginBlocked extends ComponentSync {
    timerInterval;
    componentDidMount() {
        this.timerInterval = setInterval(this.updateTimeLeft, Second);
    }
    componentWillUnmount() {
        clearInterval(this.timerInterval);
    }
    deriveStateFromProps(nextProps, state) {
        state.blockedUntil = nextProps.blockedUntil;
        state.timeLeft = state.blockedUntil - currentTimeMillis();
        return state;
    }
    updateTimeLeft = () => {
        const newTimeLeft = this.state.blockedUntil - currentTimeMillis();
        if (newTimeLeft <= 0) {
            clearInterval(this.timerInterval);
            return this.props.hide();
        }
        this.setState({ timeLeft: newTimeLeft });
    };
    renderBlockedTimer = () => {
        const totalSeconds = Math.floor(this.state.timeLeft / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
        return `${minutes}:${formattedSeconds}`;
    };
    render() {
        return _jsxs(LL_H_C, { className: 'login-blocked', children: ["Login blocked, try again in: ", this.renderBlockedTimer()] });
    }
}
//# sourceMappingURL=Component_LoginBlocked.js.map